import styled, { css } from 'styled-components'

type StyleButtonProps = {
  size?: 'display' | 'mid' | 'small' | 'custom',
  customStyles?:any,
  loadingComplete?: boolean,
  loading?: boolean,
}
function styleMyEl(size:any, customStyles?:any) {
  switch (size) {
    case 'display':
      return css`
        min-width: 80px;
        height: 40px;
        ${customStyles}
      `;
    case 'mid':
      return css`
        min-width: 80px;
        height: 36px;
        ${customStyles}
      `;
    case 'small':
      return css`
        min-width: 68px;
        height: 30px;
        padding: 5px 10px;
        ${customStyles}
      `;
    case 'custom':
      return css`
        ${customStyles}
      `;
    default:
      return css`
        height: 30px;
        ${customStyles}
      `;
  }
}
const SecondaryButton = styled.button.withConfig({
  shouldForwardProp: (prop) => !['size', 'customStyles', 'loadingComplete', 'loading'].includes(prop),
})<StyleButtonProps>`
  background: ${({theme, loadingComplete, size}) => loadingComplete ? theme.success : size === 'small' ? theme.primary[100] : theme.primary[50]};
  color: ${({theme}) => theme.primary[700]};
  padding: 10px 16px;
  border:none;
  box-sizing: border-box;
  border-radius: ${({theme}) => theme.radius.control};
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  ${({size, customStyles}) => styleMyEl(size, customStyles)}
  &:hover:not(:disabled){
    background: ${({theme, size}) => size === 'small' ? theme.primary[100] : theme.primary[50]};
    color: ${({theme}) => theme.primary[500]};
    cursor: pointer;
  }
  &:active:not(:disabled){
    background: ${({theme, size}) => size === 'small' ? theme.primary[200] : theme.primary[100]};
    color: ${({theme}) => theme.primary[700]};
  }
  &:focus-visible{
    outline: none;
    box-shadow: ${({theme}) => theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
  }
  &:disabled{
    color: ${({theme, loadingComplete, loading}) => loadingComplete || loading ? theme.primary[700] : '#FFFFFF'};
    background: ${({theme, loadingComplete, loading}) => loadingComplete || loading ? '' : theme.isDark ? theme.palette[200] : theme.grey[400]};
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    min-width: 0;
    max-width: 100%;
    min-height: 30px;
    height: auto;
    padding-left: 8px;
    padding-right: 8px;
    flex-shrink: 1;
    white-space: normal;
    overflow-wrap: anywhere;
  }
`

export default SecondaryButton
